<script lang="ts" setup>
import { useTask } from "@/stores/task";
import TaskCardHeader from "./Header.vue";
import TaskCardAction from "./Action.vue";

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
});

const taskStore = useTask();

let tmpOffsetX = 0;
let tmpOffsetY = 0;
const onItemMouseDown = (e: MouseEvent) => {
  tmpOffsetX = e.offsetX;
  tmpOffsetY = e.offsetY;
};

const onItemMouseUp = (e: MouseEvent) => {
  const { offsetX, offsetY } = e;
  if (offsetY === tmpOffsetY && offsetX === tmpOffsetX) {
    taskStore.activeTaskId = props.id;
    taskStore.showTaskDetailModal = true;
  }
};

const onItemTouchStart = (e: TouchEvent) => {
  tmpOffsetX = e.changedTouches[0].clientX;
  tmpOffsetY = e.changedTouches[0].clientY;
};

const onItemTouchEnd = (e: TouchEvent) => {
  const { clientX, clientY } = e.changedTouches[0];
  if (clientY === tmpOffsetY && clientX === tmpOffsetX) {
    taskStore.activeTaskId = props.id;
    taskStore.showTaskDetailModal = true;
  }
};

const clickItem = () => {
  taskStore.activeTaskId = props.id;
  taskStore.showTaskDetailModal = true;
};
</script>

<template>
  <div
    :class="['flex flex-col pb-3']"
    @mousedown="onItemMouseDown"
    @mouseup="onItemMouseUp"
  >
    <TaskCardHeader
      :class="[
        'flex-1 items-center',
        [2, 3].includes(taskStore.selectedType) && 'flex',
      ]"
      :id="props.id"
    />
    <TaskCardAction :id="props.id" />
  </div>
</template>
